import React, { FC } from "react";

import { Grid, Typography, Card, CardContent, Divider } from "@components/base";

interface Component {
  emission_number: string;
  emission_text: string;
  block_title: string;
  block_text: string;
}

const Component: FC<Component> = ({
  emission_number,
  emission_text,
  block_text,
  block_title,
}) =>
  emission_number ? (
    <Card sx={{ height: "100%" }}>
      <CardContent sx={{ height: "100%", p: 3 }}>
        <Grid
          container
          spacing={3}
          justifyContent="center"
          alignItems="center"
          height="100%"
        >
          <Grid size={4}>
            <Typography fontSize={72} lineHeight="72px" fontWeight={500}>
              {Math.abs(parseInt(emission_number))}%
            </Typography>
            <Typography fontSize={32} lineHeight="32px" fontWeight={500}>
              {emission_text}
            </Typography>
          </Grid>
          <Grid size={2} height="100%">
            <Divider orientation="vertical" />
          </Grid>
          <Grid size={6}>
            <Typography variant="h6">{block_title}</Typography>
            <Typography variant="body2">{block_text}</Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  ) : null;

export default Component;
